var installedModules = {};
var moduleToHandlerMapping = {
	1229: {
		getter: () => (() => (__webpack_require__(6540))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.3.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	7298: {
		getter: () => (__webpack_require__.e(123).then(() => (() => (__webpack_require__(6123))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^4.13.1",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@azure/msal-browser",
	},
	2619: {
		getter: () => (__webpack_require__.e(447).then(() => (() => (__webpack_require__(4447))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.10.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "axios",
	},
	3221: {
		getter: () => (Promise.all([__webpack_require__.e(452), __webpack_require__.e(764)]).then(() => (() => (__webpack_require__(452))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.1.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@microsoft/feature-management",
	},
	9111: {
		getter: () => (__webpack_require__.e(205).then(() => (() => (__webpack_require__(1205))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.81.5",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@tanstack/react-query",
	},
	4527: {
		getter: () => (() => (__webpack_require__(961))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.3.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	392: {
		getter: () => (__webpack_require__.e(810).then(() => (() => (__webpack_require__(6810))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.0.12",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@azure/msal-react",
	},
	2187: {
		getter: () => (__webpack_require__.e(496).then(() => (() => (__webpack_require__(4496))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.0.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@keiko-app/react-google-analytics",
	},
	3841: {
		getter: () => (Promise.all([__webpack_require__.e(651), __webpack_require__.e(228), __webpack_require__.e(868)]).then(() => (() => (__webpack_require__(9651))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^0.0.260",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@scts-ui/component-library",
	},
	7719: {
		getter: () => (() => (__webpack_require__(7672))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^7.6.2",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-router",
	},
	7908: {
		getter: () => (__webpack_require__.e(154).then(() => (() => (__webpack_require__(8154))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^6.1.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-helmet",
	},
	8186: {
		getter: () => (__webpack_require__.e(198).then(() => (() => (__webpack_require__(4817))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^4.0.3",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "linq",
	},
	9228: {
		getter: () => (() => (__webpack_require__(913))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^7.6.2",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-router",
	}
};
var initialConsumes = [1229];
__webpack_require__.federation.installInitialConsumes = () => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}))
var chunkMapping = {
	"228": [
		9228
	],
	"298": [
		7298
	],
	"527": [
		4527
	],
	"619": [
		2619
	],
	"643": [
		3221,
		9111
	],
	"792": [
		1229
	],
	"793": [
		392,
		2187,
		3841,
		7719,
		7908,
		8186
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}